export default __webpack_public_path__ + "static/un-sanctions-featured-optimized-2fb21f62e15ec579efd71763c3a3ee6e.png";